import { SELECT_SEARCH_CHAR_THRESHOLD } from '@/main';
import { debounce } from 'lodash';
import Vue from 'vue';

export const asyncSelectMixin = (resetAction: string, fetchAction: string) => {
  return Vue.extend({
    data() {
      return {
        searchPhrase: '',
        isSearchRequestPending: false,
      };
    },
    computed: {
      isSearchable(): boolean {
        return this.searchPhrase.length < SELECT_SEARCH_CHAR_THRESHOLD;
      },
    },
    methods: {
      clearSearchResults() {
        this.$store.dispatch(resetAction);
      },
      search(searchPhrase: string) {
        this.searchPhrase = searchPhrase.trim();

        if (this.isSearchable) {
          this.clearSearchResults();
          return;
        }
        this.isSearchRequestPending = true;
        this.updateSearchResults();
      },
      updateSearchResults: debounce(async function(this: any) {
        try {
          await this.$store.dispatch(fetchAction, this.searchPhrase);
        } finally {
          this.isSearchRequestPending = false;
        }
      }, 1000),
    },
  });
};
